/**
 * @file JS - classes/Page/LayoutPage.js
 * @author : Adam Lemire
 * @since 2021/09/28
 * @version 1.0
 * @summary Dernières modifications : 2021/10/27
 */

import View from 'ol/View.js';
import { EPSG } from '../../../helpers/Constants.js'; // eslint-disable-line no-unused-vars
import ElementTexte from './ElementTexte.js';
import ElementLegende from './ElementLegende.js';
import { hideContextMenus } from '../../../helpers/GlobalFunctions';
import { Evenements } from '../../../events/Evenements.js';

export default class LayoutPage {
  constructor ({ id, nomFichier, objetJSON = false }) {
    if (!objetJSON) {
      this._id = id;
      this._olMap = undefined;
      this._view = new View({
        projection: EPSG.default,
        center: [-8000000, 6000000],
        zoom: 6,
        constrainResolution: true
      });
      this._elementLegende = undefined;
      /** @type { Map < number, ElementTexte > } - id, elementTexte */
      this._elementsTexte = new Map();
      this._compteurElementTexte = 0;
      this._idConteneur = '#export-layout__preview-container';
      this._idLayout = '#layout-page-' + id;
      this._nomFichier = nomFichier;
      this._apercuCarte = 'export-layout__preview-map-' + id;
    } else {
      this._creerDepuisJSON(objetJSON);
    }
  }

  get id () { return this._id; }

  get idLayout () { return this._idLayout; }

  get elementLegende () { return this._elementLegende; }

  get nomFichier () { return this._nomFichier; }

  set nomFichier (nomFichier) {
    const idDownloadJQ = '#download-png-' + this._id;

    this._nomFichier = nomFichier;
    $(idDownloadJQ).attr('download', nomFichier + '.png');
  }

  get apercuCarte () { return this._apercuCarte; }

  get olMap () { return this._olMap; }

  set olMap (olMap) { this._olMap = olMap; }

  get olView () { return this._view; }

  creerConteneurInterne () {
    const conteneurInterne = '<div id="layout-page-' + this._id + '" class="layout-page">' +
      '<div id="export-layout__preview-map-' + this._id + '" class="export-layout__preview-map"></div>' +
      '<button class="export-layout__png-button">Exporter la carte</button>' +
      '<a id="download-png-' + this._id + '" download="' + this._nomFichier + '.png"></a>' +
    '</div>';

    $(this._idConteneur).append(conteneurInterne);
  }

  ajouterElementTexte () {
    this._compteurElementTexte++;
    const elementTexte = new ElementTexte({ idLayout: this._id, idElementTexte: this._compteurElementTexte });

    elementTexte.creerDiv();
    elementTexte.creerDivEditeur();
    this._elementsTexte.set(this._compteurElementTexte, elementTexte);
    this._ecouterAfficherMenuContextuelElementTexte(elementTexte);
  }

  ajouterElementLegende () {
    const elementLegende = new ElementLegende(this._id);

    elementLegende.creerDiv();
    elementLegende.creerDivEditeur();
    this._elementLegende = elementLegende;
    this._ecouterAfficherMenuContextuelLegende();
    $('.export-layout__legend-button').attr('disabled', true);
  }

  enleverElementLegende () {
    this._elementLegende = undefined;
  }

  creerMenuEditionElementsExistants () {
    const _this = this;
    if (this._elementLegende) {
      this._elementLegende.creerDivEditeur();
      this._ecouterAfficherMenuContextuelLegende();
      $('.export-layout__legend-button').attr('disabled', true);
    }
    this._elementsTexte.forEach(function (elementTexte, key) {
      elementTexte.creerDivEditeur();
      _this._ecouterAfficherMenuContextuelElementTexte(elementTexte);
    });
  }

  reinitialiser () {
    this._elementLegende = undefined;
    this._elementsTexte = new Map();
    this._compteurElementTexte = 0;
    this._view = new View({
      projection: EPSG.default,
      center: [-8000000, 6000000],
      zoom: 6,
      constrainResolution: true
    });
  }

  rafraichirContenuCarte () {
    if (this._elementLegende) {
      this._elementLegende.rafraichirContenuLegende();
    }
  }

  _ecouterAfficherMenuContextuelLegende () {
    const idPageLayout = this.id;
    const idDivLegende = 'layout-' + idPageLayout + '__element-legende';
    const boutonEditeurElementIdJq = '#bouton-editeur-element-legende';
    const menuContextuelIdJQ = '#context-menu-' + idDivLegende;
    let menu;

    if (!document.getElementById('context-menu-' + idDivLegende)) {
      menu = document.createElement('div');

      menu.id = 'context-menu-' + idDivLegende;
      menu.className = 'context-menu context-menu-editeur-element hidden';

      $('.inner-windows').append(menu);
      const optionSupprimer = '<ul class="context-menu__options"><li class="context-menu__option context-menu__option-editeur-element-legende" data-text="contextMenu.remove"></li></ul>';

      $(menuContextuelIdJQ).append(optionSupprimer);
      Evenements.texteAjoute.notify();
      this._ecouterEnleverEditeurElementLegende();
    } else {
      menu = document.getElementById('context-menu-' + idDivLegende);
    }

    const setPosition = ({
      top,
      left
    }) => {
      hideContextMenus();
      menu.style.left = `${left}px`;
      menu.style.top = `${top}px`;
      $(menuContextuelIdJQ).removeClass('hidden');
    };

    $(boutonEditeurElementIdJq).on('contextmenu', e => {
      e.preventDefault();
      const origin = {
        left: e.pageX,
        top: e.pageY
      };
      setPosition(origin);
      return false;
    });
  }

  _ecouterEnleverEditeurElementLegende () {
    const _this = this;
    const idPageLayout = this.id;
    const optionEnleverClasseJQ = '.context-menu__option-editeur-element-legende';
    const divElementIdJQ = '#layout-' + idPageLayout + '__element-legende';
    const enteteEditeurIdJQ = '#bouton-editeur-element-legende';
    const divEditeurIdJQ = '#editeur-element-legende';
    const menuContextuelIdJQ = '#context-menu-layout-' + idPageLayout + '__element-legende';

    $(optionEnleverClasseJQ).off('click tap');
    $(optionEnleverClasseJQ).on('click tap', function () {
      $(divElementIdJQ).remove();
      $(enteteEditeurIdJQ).remove();
      $(divEditeurIdJQ).remove();
      $(menuContextuelIdJQ).remove();
      $('.export-layout__legend-button').attr('disabled', false);
      _this.enleverElementLegende();
    });
  }

  /** @param { ElementTexte } elementTexte */
  _ecouterAfficherMenuContextuelElementTexte (elementTexte) {
    const boutonEditeurElementIdJq = '#bouton-editeur-element-' + elementTexte.id;
    const menuContextuelIdJQ = '#context-menu-' + elementTexte.idDiv;
    let menu;

    if (!document.getElementById('context-menu-' + elementTexte.idDiv)) {
      menu = document.createElement('div');

      menu.id = 'context-menu-' + elementTexte.idDiv;
      menu.className = 'context-menu context-menu-editeur-element hidden';

      $('.inner-windows').append(menu);

      const optionSupprimer = '<ul class="context-menu__options"><li class="context-menu__option context-menu__option-editeur-element-' + elementTexte.id + '" data-text="contextMenu.remove"></li></ul>';

      $(menuContextuelIdJQ).append(optionSupprimer);
      Evenements.texteAjoute.notify();
      this._ecouterEnleverEditeurElementTexte(elementTexte);
    } else {
      menu = document.getElementById('context-menu-' + elementTexte.idDiv);
    }

    const setPosition = ({
      top,
      left
    }) => {
      hideContextMenus();
      menu.style.left = `${left}px`;
      menu.style.top = `${top}px`;
      $(menuContextuelIdJQ).removeClass('hidden');
    };

    $(boutonEditeurElementIdJq).on('contextmenu', e => {
      e.preventDefault();
      const origin = {
        left: e.pageX,
        top: e.pageY
      };
      setPosition(origin);
      return false;
    });
  }

  /** @param { ElementTexte } elementTexte */
  _ecouterEnleverEditeurElementTexte (elementTexte) {
    const _this = this;
    const optionEnleverClasseJQ = '.context-menu__option-editeur-element-' + elementTexte.id;
    const divElementIdJQ = '#' + elementTexte.idDiv;
    const enteteEditeurIdJQ = '#bouton-editeur-element-' + elementTexte.id;
    const divEditeurIdJQ = '#editeur-element-texte-' + elementTexte.id;
    const menuContextuelIdJQ = '#context-menu-' + elementTexte.idDiv;

    $(optionEnleverClasseJQ).on('click tap', function () {
      $(divElementIdJQ).remove();
      $(enteteEditeurIdJQ).remove();
      $(divEditeurIdJQ).remove();
      $(menuContextuelIdJQ).remove();
      _this._elementsTexte.delete(elementTexte.id);
    });
  }

  /*
   * EXPORTATION JSON
   */

  toJSON () {
    const objetJSON = {
      id: this._id,
      view: {
        projection: this._view.getProjection().getCode(),
        center: this._view.getCenter(),
        extent: this._olMap ? this._view.calculateExtent(this._olMap.getSize()) : this._jsonView.extent,
        resolution: this._view.getResolution(),
        mapSize: this._olMap ? this._olMap.getSize() : this._jsonView.mapSize
      },
      elementLegende: this._elementLegende ? this._elementLegende.toJSON() : false,
      elementsTexte: this._convertirElementsTexteEnJSON(),
      compteurElementTexte: this._compteurElementTexte,
      nomFichier: this._nomFichier
    };
    return objetJSON;
  }

  /** @returns { object [] } [{number, ElementTexte}] */
  _convertirElementsTexteEnJSON () {
    const elementsTexteJSON = [];
    for (const [id, elementTexte] of this._elementsTexte) {
      elementsTexteJSON.push({ id: id, elementTexte: elementTexte.toJSON() });
    }
    return elementsTexteJSON;
  }

  /*
   * OUVERTURE DEPUIS JSON
   */

  /**
   * @param { object } objetJSON
   * @param { number } objetJSON.id
   * @param { object } objetJSON.view
   * @param { object } objetJSON.elementLegende
   * @param { object [] } objetJSON.elementsTexte
   * @param { number } objetJSON.compteurElementTexte
   * @param { string } objetJSON.nomFichier
   */
  _creerDepuisJSON (objetJSON) {
    this._id = objetJSON.id;
    this._view = new View({
      projection: objetJSON.view.projection,
      center: objetJSON.view.center,
      zoom: 6,
      constrainResolution: true
    });
    this._elementLegende = undefined;
    this._elementsTexte = new Map();
    this._compteurElementTexte = objetJSON.compteurElementTexte;
    this._idConteneur = '#export-layout__preview-container';
    this._idLayout = '#layout-page-' + objetJSON.id;
    this._nomFichier = objetJSON.nomFichier;
    this._apercuCarte = 'export-layout__preview-map-' + objetJSON.id;
    this._jsonView = objetJSON.view; // nécessaire si réenregistre projet sans avoir réouvert le layout, car _olMap serait undefined
  }

  /** @param { object } objetJSON */
  activerDepuisJSON (objetJSON) {
    this.creerConteneurInterne();

    if (objetJSON) {
      this._elementLegende = this._creerElementLegendeDepuisJSON(objetJSON);
      this._elementsTexte = this._creerElementsTexteDepuisJSON(objetJSON.elementsTexte);

      this._view.setResolution(objetJSON.view.resolution);
    }
  }

  /**
   * @param { object } objetJSON
   * @returns { ElementLegende }
   */
  _creerElementLegendeDepuisJSON (objetJSON) {
    if (objetJSON.elementLegende) {
      const elementLegende = new ElementLegende(objetJSON.id, objetJSON.elementLegende);

      elementLegende.creerDiv();
      return elementLegende;
    } else { return undefined; }
  }

  /**
   * @param { object } elementsTexteJSON
   * @returns { Map<number, ElementTexte>}
   */
  _creerElementsTexteDepuisJSON (elementsTexteJSON) {
    /** @type { Map<number, ElementTexte> } */
    const elementsTexte = new Map();
    elementsTexteJSON.forEach(function (elementTexteLigne) {
      const mElementTexte = new ElementTexte({ objetJSON: elementTexteLigne.elementTexte });

      mElementTexte.creerDiv();
      elementsTexte.set(elementTexteLigne.id, mElementTexte);
    });
    return elementsTexte;
  }
}
